"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Marquee = _interopRequireDefault(require("../assets/Marquee.css"));

var _Text = _interopRequireDefault(require("./Text"));

var _panoNoticeBar = _interopRequireDefault(require("pano-notice-bar"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _jsxFileName = "E:\\720\\720yun_player\\packages\\pano-marquee\\src\\Marquee.js";

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Marquee["default"]);

var Marquee = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Marquee, _React$PureComponent);

  function Marquee() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      init: false,
      marquee: false
    });

    _defineProperty(_assertThisInitialized(_this), "compute", function () {
      var clientWidth = _this.dom.clientWidth;
      var _this$props = _this.props,
          maxWidth = _this$props.maxWidth,
          text = _this$props.text;
      var marquee = false;

      if (!maxWidth) {
        maxWidth = _this.initwp.parentNode.clientWidth + 2;
      }

      if (maxWidth < clientWidth) {
        marquee = true;
      }

      _this.setState({
        marquee: marquee,
        init: true,
        clientWidth: clientWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "init", function () {});

    return _this;
  }

  var _proto = Marquee.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.compute();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var text = this.props.text;
    var prevText = prevProps.text;

    if (text !== prevText) {
      this.setState({
        init: false
      });
    }

    var init = this.state.init;
    var prevInit = prevState.init;

    if (prevInit && !init) {
      this.compute();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        text = _this$props2.text,
        fontSize = _this$props2.fontSize,
        maxWidth = _this$props2.maxWidth,
        align = _this$props2.align,
        disable = _this$props2.disable,
        _this$props2$disableC = _this$props2.disableColor,
        disableColor = _this$props2$disableC === void 0 ? "#fff" : _this$props2$disableC,
        _this$props2$color = _this$props2.color,
        color = _this$props2$color === void 0 ? "#fff" : _this$props2$color,
        mouseEnterPause = _this$props2.mouseEnterPause;
    var _this$state = this.state,
        marquee = _this$state.marquee,
        init = _this$state.init,
        clientWidth = _this$state.clientWidth;

    if (!init) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(me) {
          return _this2.initwp = me;
        },
        style: {
          maxWidth: maxWidth,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 9
        }
      }, text, /*#__PURE__*/_react["default"].createElement("span", {
        ref: function ref(me) {
          return _this2.dom = me;
        },
        style: {
          fontSize: fontSize,
          visibility: "hidden",
          position: "absolute"
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 52,
          columnNumber: 11
        }
      }, text));
    }

    if (!marquee) {
      // +2 兼容“小镇风光-1”
      return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        style: {
          color: disable ? disableColor : color
        },
        text: text,
        fontSize: fontSize,
        align: align,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 14
        }
      });
    }

    if (disable) {
      return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        style: {
          color: disable ? disableColor : color,
          maxWidth: maxWidth
        },
        text: text,
        fontSize: fontSize,
        align: align,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63,
          columnNumber: 14
        }
      });
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cx("Marquee"),
      style: {
        width: maxWidth,
        fontSize: fontSize
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 7
      }
    }, /*#__PURE__*/_react["default"].createElement(_panoNoticeBar["default"], {
      mouseEnterPause: mouseEnterPause,
      color: color,
      speed: 30,
      style: {
        height: "100%",
        fontSize: fontSize,
        background: "transparent"
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 9
      }
    }, text));
  };

  return Marquee;
}(_react["default"].PureComponent);

var _default = Marquee;
exports["default"] = _default;
module.exports = exports.default;